import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "relative",
    display: "flex",
    width: "fit-content",
  },
  rank: {
    position: "absolute",
    right: -5,
    bottom: -8,
  },
  avatar: {
    borderRadius: "50%",
  },
  status: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    position: "absolute",
    zIndex: theme.zIndex.normal,
    insetInlineEnd: -theme.spacing.space4,
    top: 0,
  },
  fireIcon: {
    position: "absolute",
    bottom: 0,
    insetInlineEnd: 0,
  },
}));
